import {quizActions, useQuiz} from "../../providers/QuizProvider.tsx";

interface TextQuestionProps {
    name: string;
    label: string;
    placeholder?: string;
    required?: boolean;
    type?: 'text' | 'email' | 'tel' | 'number';
    multiline?: boolean;
}

const TextQuestion = ({name, label, placeholder, required = false, type = 'text', multiline = false}: TextQuestionProps) => {
    const {state, dispatch} = useQuiz();
    const value = state.formData[name] || '';

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        dispatch(quizActions.updateFormData({[name]: e.target.value}));
    };

    return (
        <div className="mb-6">
            <label className="block text-sm font-medium mb-2">
                {label}
                {required && <span className="text-red-500 ml-1">*</span>}
            </label>
            {multiline ? (
                <textarea
                    value={value}
                    onChange={handleChange}
                    placeholder={placeholder}
                    required={required}
                    rows={4}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
            ) : (
                <input
                    type={type}
                    value={value}
                    onChange={handleChange}
                    placeholder={placeholder}
                    required={required}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
            )}
        </div>
    );
};

export default TextQuestion;